import { tokens } from '@hotjar/hotsauce';
import { keyframes } from '@emotion/react';
import styled from '@emotion/styled';

export const FULL_SIZE = 64;
const DURATION = 2.5;
const TRANSLATE_LENGTH = FULL_SIZE * 0.3;

const appearAndDisappear = keyframes`
        from {
            transform: scale(0);
        }
        13%,
        96% {
            transform: scale(1);
        }
        to {
            transform: scale(0);
        }
`;

const rotateGlobally = keyframes`
        from,
        15% {
            transform: rotate(0deg);
        }
        95%,
        to {
            transform: rotate(330deg);
        }
`;

const translateFromCenter = (translateEnd: number) => keyframes`
            from,
            12% {
                transform: translateX(0);
            }
            25%,
            ${translateEnd}% {
                transform: translateX(${TRANSLATE_LENGTH}px);
            }
            to {
                transform: translateX(0);
            }
        `;

const bumpRotation = (rotationStart: number) => keyframes`
         from,
            ${rotationStart}% {
                transform: rotate(0deg);
            }
            ${rotationStart + 6}%,
            to {
                transform: rotate(72deg);
            }
        `;

const BallSpinnerSvg = styled.svg`
  width: ${FULL_SIZE}px;
  height: ${FULL_SIZE}px;
  z-index: 100;
`;

const BallSpinnerContainer = styled.g`
  transform: translate(${FULL_SIZE / 2}px, ${FULL_SIZE / 2}px);
`;

const LevelOne = styled.g`
  animation: ${rotateGlobally} ${DURATION}s linear infinite;
`;

const Level = styled.g<{ rotationStart: number }>`
  animation: ${({ rotationStart }) => bumpRotation(rotationStart)} ${DURATION}s infinite;
`;

const Circle = styled.circle`
  animation: ${appearAndDisappear} ${DURATION}s infinite;
  fill: ${tokens.BRAND_COLORS.ember_600};
`;

Circle.defaultProps = { r: '4.5' };

const CircleWrapper = styled.g<{
  translateEnd: number;
}>`
  animation: ${({ translateEnd }) => translateFromCenter(translateEnd)} ${DURATION}s infinite;
`;

export function BallSpinner(): JSX.Element {
  return (
    <BallSpinnerSvg>
      <BallSpinnerContainer>
        <LevelOne>
          <CircleWrapper translateEnd={82}>
            <Circle />
          </CircleWrapper>
          <Level rotationStart={29}>
            <CircleWrapper translateEnd={84}>
              <Circle />
            </CircleWrapper>
            <Level rotationStart={44}>
              <CircleWrapper translateEnd={85}>
                <Circle />
              </CircleWrapper>
              <Level rotationStart={59}>
                <CircleWrapper translateEnd={87}>
                  <Circle />
                </CircleWrapper>
                <Level rotationStart={74}>
                  <CircleWrapper translateEnd={88}>
                    <Circle />
                  </CircleWrapper>
                </Level>
              </Level>
            </Level>
          </Level>
        </LevelOne>
      </BallSpinnerContainer>
    </BallSpinnerSvg>
  );
}
